/* eslint-disable no-restricted-globals */
import { Tag } from 'components';
import { RoundedButton } from 'components/NewInputs';
import I18n from 'i18n-js';
import { navigate } from 'navigation';
import React from 'react';
import { Colors } from 'styles';
// import { InscritosModel } from 'types/models/inscritos';
import styles from './comunities-solicitudes-pendiente-list-page-new-onboarding-row.module.scss';

interface PendingRequestTableRowProps {
  row: any;
  communityID: string;
}

const PasoLabels: Record<number, string> = {
  1: I18n.t('PasosOnboarding.DATOS INICIALES'),
  2: I18n.t('PasosOnboarding.DATOS DE FACTURA'),
  3: I18n.t('PasosOnboarding.ENCUESTA OBLIGATORIA'),
  4: I18n.t('PasosOnboarding.SELECCIÓN COMUNIDAD'),
  5: I18n.t('PasosOnboarding.ACCESO DATADIS'),
  6: I18n.t('PasosOnboarding.ACEPTACIÓN OFERTAS'),
  7: I18n.t('PasosOnboarding.FIRMA CONTRATO'),
  8: I18n.t('PasosOnboarding.DOCUMENTO REPARTO'),
};

export const parseISOToDate = (value: unknown): Date | null => {
  if (!value) return null;
  if (value instanceof Date) return value;
  if (typeof value === 'number') return new Date(value);

  if (typeof value === 'string') {
    // recorta microsegundos (p.ej. .763199 -> .763) para Date()
    const fixed = value.replace(/\.(\d{3})\d+/, '.$1');
    const d = new Date(fixed);
    return isNaN(d.getTime()) ? null : d;
  }
  return null;
};

export const formatFecha = (input: unknown, locale: 'es-ES' | 'ca-ES' = 'es-ES', withSeconds = false): string => {
  const d = parseISOToDate(input);
  if (!d) return '—';

  const opts: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    ...(withSeconds ? { second: '2-digit' } : {}),
  };

  return new Intl.DateTimeFormat(locale, opts).format(d);
};

export const PendingRequestTableRow = (props: PendingRequestTableRowProps): JSX.Element => {
  let url: string;
  const { row, communityID } = props;
  const { t } = I18n;
  const loc = String(I18n.locale || 'es').startsWith('ca') ? 'ca-ES' : 'es-ES';

  if (communityID === undefined) {
    url = `/tecnic/solicitudes-pendientes/${row.id}/solicitud`;
  } else {
    url = `/tecnic/communities/${communityID}/${row.id}/solicitud`;
  }
  const pasoActual = row.pasos?.find((p: any) => !p.acabado)?.paso ?? '✔'; // Todos finalizados → check
  const fechaFinalRaw = row.pasos?.find((p: any) => !p.acabado)?.fecha_start;
  return (
    <tr className={styles.mainrow}>
      <td>{formatFecha(fechaFinalRaw, loc /* 'es-ES' | 'ca-ES' */, false)}</td>
      <td>
        {row.nombre ?? '—'} {row.apellidos ?? ''}
      </td>
      <td>{row.email ?? '—'}</td>
      <td>{row.telefono ?? '—'}</td>
      <td>{row.cups ?? '—'}</td>
      <td>{row.nombre_comunidad || '—'}</td>
      <td>
        <Tag color={Colors.COLOR_GENERACIO}>
          {typeof pasoActual === 'number' ? `${PasoLabels[pasoActual]}` : t('Completado')}
        </Tag>
      </td>

      <td>
        <RoundedButton onClick={() => navigate(url)}>{t(`ComunitiesEnrolledListPage.detalles`)}</RoundedButton>
      </td>
    </tr>
  );
};
